import { useContactChannelsContext as r } from "./contact-channels19.js";
import { checkCallMeSpamProtection as n } from "./contact-channels74.js";
import { useQuery as o } from "./contact-channels42.js";
const m = (t = !0) => {
  const { callMeConfig: e } = r();
  return o({
    queryKey: ["c2c-spam"],
    queryFn: () => n(e == null ? void 0 : e.allowVPNs),
    staleTime: 1 / 0,
    gcTime: 1 / 0,
    retry: !1,
    refetchOnWindowFocus: !1,
    refetchInterval: !1,
    enabled: t
  });
};
export {
  m as useCheckC2CSpam
};
//# sourceMappingURL=contact-channels48.js.map
